
export default {

    list_crop: [
        { value: 1,   text: '水稻' },
        { value: 2,   text: '玉米' },
        { value: 517, text: '鳳梨' },
    ],

    cropperiods:
    [
        {
          "id": 1,
          "project_id": 1,
          "crop_info_id": 1,
          "name": "金鑽鳳梨第一期",
          "farm_field": "田區C",
          "description": "好吃的油雞鳳梨",
          "start_date": "2017-08-30",
          "boundary": null,
          "pic": null,
          "stage": "P2",
          "current_percentage": 28,
          "whole_percentage": 8,
          "day_next": 28
        },
        {
            "id": 4,
            "project_id": 2,
            "crop_info_id": 1,
            "name": "玉蘭花鳳梨第二期",
            "farm_field": "田區D",
            "description": "好吃的油雞鳳梨",
            "start_date": "2017-10-05",
            "boundary": null,
            "pic": null,
            "stage": "P2",
            "current_percentage": 34,
            "whole_percentage": 9,
            "day_next": 30
        }
    ],

    cropperiod_detail:
    {
        "id": 1,
        "project_id": 1,
        "crop_info_id": 1,
        "name": "金鑽鳳梨第一期",
        "farm_field": "田區C",
        "description": "好吃的油雞鳳梨",
        "start_date": "2017-08-30",
        crop_name: '鳳梨',         //作物種類
        cultivar_name: '金鑽鳳梨', //作物品種
        "boundary": null,
        weather_location: '高雄市-2304505',
        "pic": null,
        "stage": "P2",
        "current_percentage": 28,
        "whole_percentage": 8,
        "day_next": 28,
    },

    growth_period:
    [
        {
            code: 'crown_planting',
            "stage": "P6",         // 生長期代碼
            "name": "採苗及栽植期", // 顯示名稱
            "definition": "",     // 定義 / 說明
            "period": [23,0]      // 持續時間(天) [ 已經歷幾天, 未來剩幾天 ]
        },
        {
            code: 'foliage_and_root_growth',
            "stage": "P1",
            "name": "植株發育期",
            "definition": "",
            "period": [100,0]
        },
        {
            code: 'forcing',
            "stage": "P2",
            "name": "催花期",
            "definition": "",
            "period": [60,0]
        },
        {
            code: 'flowering',
            "stage": "P3",
            "name": "開花期",
            "definition": "",
            "period": [60,0]
        },
        {
            code: 'fruiting',
            "stage": "P4",
            "name": "果實發育期",
            "definition": "",
            "period": [90,0]
        },
        // {
        //     code: 'harvesting',
        //     "stage": "P5",
        //     "name": "果實成熟期 採收期",
        //     "definition": "",
        //     "period": [10,0]
        // },
        // {
        //     code: 'harvesting',
        //     "stage": "P6",
        //     "name": "Test 6",
        //     "definition": "",
        //     "period": [10,0]
        // },
        // {
        //     code: 'harvesting',
        //     "stage": "P7",
        //     "name": "Test 7",
        //     "definition": "",
        //     "period": [30,0]
        // },
        // {
        //     code: 'harvesting',
        //     "stage": "P8",
        //     "name": "Test 8",
        //     "definition": "",
        //     "period": [8,0]
        // },
        {
            code: 'harvesting',
            "stage": "P5",//"P9",
            "name": "Test 9",
            "definition": "",
            "period": [9,15]
        }
    ],
}